const Spinner = ({ size = 14, className = "" }) => (
  <span
    className={`inline-block border-2 border-[#D1D1D4] border-t-[#111827] rounded-full animate-spin ${className}`}
    style={{ width: size, height: size }}
  />
);

export default Spinner;
